import React, { Component } from "react";
import { ReactComponent as BoldSVG } from "../../images/svg/bold.svg";
import { ReactComponent as ItalicSVG } from "../../images/svg/italic.svg";
import { ReactComponent as UListSVG } from "../../images/svg/ulist.svg";
import { ReactComponent as OListSVG } from "../../images/svg/olist.svg";
import { ReactComponent as LinkSVG } from "../../images/svg/link.svg";
import { ReactComponent as UnlinkSVG } from "../../images/svg/unlink.svg";
import { ReactComponent as PictureSVG } from "../../images/svg/picture.svg";

class Editor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      post: "",
      csrf_token: ""
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.alertMsg = this.alertMsg.bind(this);
    this.update = this.update.bind(this);

    this.bold = this.bold.bind(this);
    this.italic = this.italic.bind(this);
    this.oList = this.oList.bind(this);
    this.uList = this.uList.bind(this);
    this.link = this.link.bind(this);
    this.unLink = this.unLink.bind(this);
    this.image = this.image.bind(this);

    this.toggleEditorExecBtnColor = this.toggleEditorExecBtnColor.bind(this);
    this.enableEditor = this.enableEditor.bind(this);
    this.cleanEditor = this.cleanEditor.bind(this);
    this.validateImage = this.validateImage.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
  }

  cleanEditor(alertElem) {
    setTimeout(function() {
      alertElem.classList.remove("success-alert");
      alertElem.innerHTML = "";

      let editor = document.getElementById("admin_editor_frame");
      document.querySelector("#admin_editor_ta").value = "";
      editor.contentWindow.document.body.innerHTML = "";

      let parentExec = document.querySelector(".editor-exec-btn-wrapper-admin");
      let execBtns = parentExec.querySelectorAll(".green-fill").length;
      for (let i = 0; i < execBtns; i++) {
        parentExec.querySelectorAll(".green-fill")[i].classList.add("neutral");

        parentExec
          .querySelectorAll(".green-fill") // eslint-disable-next-line
          [i].classList.remove("green-fill");
      }
    }, 1000);
  }

  alertMsg(elem, className, errorMessage) {
    elem.classList.remove("success-alert");
    elem.classList.remove("error-alert");

    elem.classList.add(className);
    elem.innerHTML = errorMessage;
  }

  toggleEditorExecBtnColor(elem) {
    if (elem.classList.contains("neutral")) {
      elem.classList.remove("neutral");
      elem.classList.add("green-fill");
    } else {
      elem.classList.add("neutral");
      elem.classList.remove("green-fill");
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.post !== nextProps.post) {
      let editor = document.querySelector("#admin_editor_frame");
      editor.contentWindow.document.body.innerHTML = nextProps.post;
    }
  }

  enableEditor(e) {
    e.preventDefault();
    let editor = document.getElementById("admin_editor_frame");
    editor.contentWindow.document.designMode = "On";
    e.target.style.display = "none";
  }

  bold() {
    let elem = document.querySelector(".editor-ad-bold-btn");
    this.toggleEditorExecBtnColor(elem);
    window.frames.admin.document.execCommand("bold", false, null);
  }

  italic() {
    let elem = document.querySelector(".editor-ad-italic-btn");
    this.toggleEditorExecBtnColor(elem);
    window.frames.admin.document.execCommand("italic", false, null);
  }

  oList() {
    let elem = document.querySelector(".editor-ad-olist-btn");
    this.toggleEditorExecBtnColor(elem);
    window.frames.admin.document.execCommand(
      "InsertOrderedList",
      false,
      "newOL"
    );
  }

  uList() {
    let elem = document.querySelector(".editor-ad-ulist-btn");
    this.toggleEditorExecBtnColor(elem);
    window.frames.admin.document.execCommand(
      "InsertUnorderedList",
      false,
      "newUL"
    );
  }

  link() {
    let linkURL = prompt("Enter the URL for this link:", "http://");
    window.frames.admin.document.execCommand("CreateLink", false, linkURL);
  }

  unLink() {
    window.frames.admin.document.execCommand("Unlink", false, null);
  }

  validateImage(image) {
    let alertElem = document.querySelector("#alert-admin");
    if (image.name === "") {
      this.alertMsg(alertElem, "error-alert", "Please select an image");
      this.setState({ hasError: true });
      return false;
    }

    let extension = image.type
      .split("/")
      .pop()
      .toLowerCase();
    if (["jpg", "png", "jpeg"].indexOf(extension) === -1) {
      this.alertMsg(
        alertElem,
        "error-alert",
        "The selected file is not an image"
      );
      return false;
    }

    if (image.size > 4500000) {
      this.alertMsg(
        alertElem,
        "error-alert",
        "Image should not be more than 4mb"
      );
      return false;
    }
    return true;
  }

  image(e) {
    let alertElem = document.querySelector("#alert-admin");

    this.alertMsg(alertElem, "success-alert", "Image is being uploaded...");

    let image = e.target.files[0];
    if (this.validateImage(image)) {
      this.uploadImage(image, alertElem);
    }
  }

  uploadImage(image, alertElem) {
    const formdata = new FormData();
    formdata.append("admin_image", image);
    fetch(`${this.props.apiROOT}imageUpload`, {
      method: "post",
      body: formdata
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          let src = `${this.props.root}public/images/admin_pic/${data.imageName}`;
          window.frames.admin.document.execCommand("insertimage", false, src);
          this.alertMsg(alertElem, "success-alert", "Image uploaded");
        } else {
          this.alertMsg(alertElem, "error-alert", "An error occurred");
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  update(formdata) {
    let alertElem = document.querySelector("#alert-admin");
    this.alertMsg(alertElem, "success-alert", "Please wait...");
    fetch(`${this.props.apiROOT}others/${this.props.page}`, {
      method: "post",
      body: formdata
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          this.alertMsg(
            alertElem,
            "success-alert",
            this.props.page + " page updated"
          );
        } else {
          this.alertMsg(alertElem, "error-alert", "An error occured");
        }
      });
  }

  onSubmit(e) {
    e.preventDefault();

    let editor = document.getElementById("admin_editor_frame");
    document.querySelector("#admin_editor_ta").value =
      editor.contentWindow.document.body.innerHTML;
    const a_post = document.querySelector("#admin_editor_ta").value;

    let formdata = new FormData();
    formdata.append("post", a_post);
    formdata.append("csrf_token", this.props.csrf_token);

    this.update(formdata);
  }

  render() {
    return (
      <form
        className="editor shadow"
        id="create-admin-form"
        onSubmit={this.onSubmit}
      >
        <small id="alert-admin" />

        <button
          className="btn"
          style={{ textAlign: "center", width: 30 + "%", marginLeft: 35 + "%" }}
          onClick={this.enableEditor}
        >
          Enable Editor
        </button>
        <div className="editor-exec-btn-wrapper editor-exec-btn-wrapper-admin">
          <button
            type="button"
            className="editor-ad-bold-btn neutral"
            onClick={this.bold}
          >
            <BoldSVG />
          </button>
          <button
            type="button"
            className="editor-ad-italic-btn neutral"
            onClick={this.italic}
          >
            <ItalicSVG />
          </button>
          <button
            type="button"
            className="editor-ad-olist-btn neutral"
            onClick={this.oList}
          >
            <OListSVG />
          </button>
          <button
            type="button"
            className="editor-ad-ulist-btn neutral"
            onClick={this.uList}
          >
            <UListSVG />
          </button>
          <button
            type="button"
            className="editor-ad-link-btn neutral"
            onClick={this.link}
          >
            <LinkSVG />
          </button>
          <button
            type="button"
            className="editor-ad-unlink-btn neutral"
            onClick={this.unLink}
          >
            <UnlinkSVG />
          </button>
          <label
            htmlFor="comment-image"
            className="editor-ad-picture-btn neutral"
          >
            <PictureSVG />
          </label>
          <input
            type="file"
            id="comment-image"
            style={{ display: "none" }}
            onChange={this.image}
          />
        </div>

        <div className="input-wrapper">
          <textarea id="admin_editor_ta" name="post" rows="10" />
          <iframe name="admin" id="admin_editor_frame" title="mmm" />
        </div>

        <div className="input-wrapper">
          <button type="submit" className="btn">
            Update {this.props.page}
          </button>
        </div>
      </form>
    );
  }
}

export default Editor;
